import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'medpace-vertical-stepper-link',
    standalone: true,
    templateUrl: './vertical-stepper-link.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./../../../organisms/stepper/vertical-stepper.component.scss'],
})
export class VerticalStepperLinkComponent {
    @Input()
    stepName: string;

    @Input()
    isActive: boolean;

    @Input()
    stepIdentifier: string;

    @Input()
    offsetElement: HTMLElement;

    onClick() {
        let element = document.getElementById(this.stepIdentifier);
        window.scrollTo({ top: element.offsetTop });
    }
}
